var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import * as actions from '../constants';
/* Initial State */

var initialState = {
  token: undefined,
  tokenContent: undefined,
  isFetching: false,
  user: undefined,
  error: undefined
};
/* Reducer */

export var user = function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.LOG_IN_REQUEST:
    case actions.SUBMIT_SELF_REGISTRATION_REQUEST:
    case actions.RESET_PASSWORD_REQUEST:
    case actions.READ_USER_DETAILS_REQUEST:
    case actions.USER_VERIFY_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.LOG_IN_SUCCESS:
    case actions.RESET_PASSWORD_SUCCESS:
    case actions.SUBMIT_SELF_REGISTRATION_SUCCESS:
    case actions.USER_REGISTER_SUCCESS:
      return _extends({}, state, action.payload, {
        isFetching: false,
        error: undefined
      });

    case actions.READ_USER_DETAILS_SUCCESS:
      return _extends({}, state, {
        user: _extends({}, action.payload),
        isFetching: false,
        error: undefined
      });

    case actions.SUBMIT_SELF_REGISTRATION_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.LOG_IN_FAILURE:
    case actions.READ_USER_DETAILS_FAILURE:
    case actions.USER_VERIFY_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.RESET_PASSWORD_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.LOG_OUT_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.LOG_OUT_SUCCESS:
      return initialState;

    case actions.REFRESH_TOKEN_FAILURE:
      return _extends({}, initialState, {
        error: 'User session expired'
      });

    case actions.USER_REGISTER_FAILURE:
      return _extends({}, initialState, {
        error: 'Registration failed. ' + action.error + ' If issue persists, please contact your account administrator.'
      });

    case actions.LOG_OUT_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.FORGOT_PASSWORD_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.FORGOT_PASSWORD_SUCCESS:
      return _extends({}, state, {
        isFetching: false,
        error: undefined
      });

    case actions.FORGOT_PASSWORD_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.DECODE_TOKEN_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.DECODE_TOKEN_SUCCESS:
      return _extends({}, state, {
        tokenContent: action.payload,
        isFetching: false,
        error: undefined
      });

    case actions.DECODE_TOKEN_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.error
      });

    case actions.REFRESH_TOKEN_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: undefined
      });

    case actions.CLEAR_LOGIN_FORM:
    case actions.REFRESH_TOKEN_SUCCESS:
      return _extends({}, state, {
        isFetching: false,
        error: undefined
      });

    case actions.USER_UPDATE_SUCCESS:
    case actions.USER_VERIFY_SUCCESS:
      return _extends({}, state, {
        user: _extends({}, action.payload),
        isFetching: false,
        error: undefined
      });

    default:
      return state;
  }
};